<template>
  <div class="title">
    <p>Сумма</p>
    <p>
      <span>{{summVuex | moneyFormat}}</span>
<!--      <span class="rubl">a</span>-->
    </p>
  </div>
</template>

<script>
  //todo summVuex, должно быть редактируемым инпутом
  import {mapState} from 'vuex';

  export default {
    name: "rangeTopLine",
    computed: {
      ...mapState({
        summVuex: state => state.Deal.SelectedSumm,
      })
    }
  }
</script>

<style scoped>


  .title {display: flex;justify-content: space-between;align-items: center}
  .title {font-size: 4.3vw;padding-top: 5vw;}

  @media screen and (min-width: 760px) {

    .title {font-size: 1.4vw;padding-top: 0;}

  }
  @media screen and (min-width: 1140px) {

    .title {font-size: 16px}

  }

</style>
